import { Switch, Upload, message } from "antd";
import React, { useState } from "react";
import { Form, FormGroup } from "react-bootstrap";
import { AcrobatIcon, DropPDF } from "../../../../../../constants/svg";
import CustomUploader from "../../../../../Common/CustomUploader";

const PdfUpload = ({
  handleChange,
  fileList,
  resetField,
  handleSwitch,
  switchDefaultValue,
  linkDefaultValue,
}) => {
  const [switchValue, setSwitchValue] = useState(false);
  const [resourceLink, setResourceLink] = useState("");

  // Only allow PDF, Word, or image files
  const UploadProps = {
    multiple: false,
    name: "file",
    accept: ".pdf,.png,.jpg,.jpeg,.doc,.docx",
    beforeUpload: (file) => {
      const isAllowedType =
        file.type === "application/pdf" ||
        file.type === "application/msword" ||
        file.type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
        file.type.startsWith("image/");

      const isZip = file.name.toLowerCase().endsWith(".zip");

      if (isZip) {
        message.error("ZIP files are not allowed.");
        return Upload.LIST_IGNORE;
      }

      if (!isAllowedType) {
        message.error("Only PDF, Word, or image files are allowed.");
        return Upload.LIST_IGNORE;
      }

      return true;
    },
  };

  const handleSwitchChange = (checked) => {
    resetField("uploadPDF");
    setResourceLink("");
    setSwitchValue(checked);
    handleSwitch(checked);
  };

  const handleInputLink = (event) => {
    setResourceLink(event.target.value);
    handleChange(event.target.value);
  };

  return (
    <>
      <div className="uploadHeader d-flex justify-content-between align-items-center">
        <div className="title">Upload a PDF or link to a resource online.</div>
        <p className="m-0 link-to-resource-label">
          Link to resource instead
          <Switch
            checked={switchDefaultValue || switchValue}
            onChange={handleSwitchChange}
            className="custom-ml-05"
          />
        </p>
      </div>

      {!switchValue && !switchDefaultValue ? (
        <div className="addLink-Box resource-pdf">
          <CustomUploader
            {...UploadProps}
            showUploadList={{
              showDownloadIcon: false,
              showPreviewIcon: false,
            }}
            listType="text"
            fileList={fileList == "" ? [] : [fileList]}
            onChange={(e) => {
              const fileList = e.fileList;
              handleChange(
                !fileList.length
                  ? ""
                  : fileList.length > 1
                    ? fileList[1]
                    : fileList[0],
              );
            }}
            className="border-0 bg-0 custom-uploader"
            beforeUpload={() => {
              /* update state here */
              return false;
            }}
          >
            <DropPDF />
          </CustomUploader>
        </div>
      ) : (
        <div className="uploaderBox floatedLabel">
          <FormGroup className="form-label-group">
            <Form.Label htmlFor="resourceLink">Resource Link</Form.Label>
            <Form.Control
              type="link"
              id="resourceLink"
              placeholder="https://"
              value={linkDefaultValue || resourceLink}
              onChange={handleInputLink}
              required
            />
          </FormGroup>
        </div>
      )}
    </>
  );
};

export default PdfUpload;
